import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { Map } from 'immutable';
import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { getOperatorName } from './getOperatorName';
import { convertActionValue, getActionValue } from '../../action';

export function convertConditions(
	condition: RuleEngineLegacyEntities.ICondition,
	formData: Map<string, LayoutCreatorEntities.LayoutItem>,
	getFactKeys: (factKey: string) => void
): any {
	const fieldFact = [condition.field.name, condition.field.propertyName].join('.');
	if (getFactKeys) {
		getFactKeys(fieldFact);
	}

	let value = condition.value;

	if (
		condition.typeName === 'FieldSelectionCondition' &&
		condition.operation !== 'Null' &&
		condition.operation !== 'NotNull'
	) {
		const controlName = condition.selectedField.name;
		const propKey = condition.selectedField.propertyName;

		const selectedFieldFact = condition.selectedField ? [controlName, propKey].join('.') : null;
		if (getFactKeys) {
			getFactKeys(selectedFieldFact);
		}

		const actionValue = getActionValue(controlName, propKey, formData);
		value = convertActionValue(
			condition.selectedField,
			actionValue,
			formData,
			propKey.split('.'),
			true
		).value;
	}

	return {
		fact: fieldFact,
		operator: getOperatorName(condition.operation),
		value
	};
}
